import { experiments } from '../../../experiments/client';
import { helpCenterService } from '../helpCenter';

class HomepageService {
  get homepageEnabled(): boolean {
    // TODO: split 'specs.engage.enableNewFullPage' and 'specs.engage.enableHomepage'
    return helpCenterService.isFullWidth
      ? experiments.is('specs.engage.enableNewFullPage', 'true')
      : experiments.is('specs.engage.enableHomepage', 'true');
  }
}

export const homepageService = new HomepageService();
